import React from 'react'
import PropTypes from 'prop-types'
import SignUpButton from './SignUpButton'

/**
 * A react component that controls when to display the Sign Up functionality
 */
const SignUpControl = (props) => (
	props.visible
		?
		<div className="SignUpControl">
			{React.Children.map(props.children, (child) => React.cloneElement(child, {click: props.click}))}
		</div>
		:
		null
)


SignUpControl.propTypes = {
	visible: PropTypes.bool.isRequired,
	click: PropTypes.func.isRequired,
	children: PropTypes.element.isRequired
}

SignUpControl.defaultProps = {
	children: <SignUpButton text='Sign Up'/>
}

export default SignUpControl



// WEBPACK FOOTER //
// ./src/components/SignUpControl/SignUpControl.js